import { setScreenData, ACTIVE_SCREEN_KEY, Store, getScreenData, showDialog, hideDialog } from 'cw-ui-core';
import { toArray } from 'src/util/Util';
import { call, put, all } from 'redux-saga/effects';
import { GET, PUT, getHeaders } from 'src/services/ApiService';
import { READ, DELETE } from 'src/features/notifications/constants';
import { DEFAULT_LOADING_DIALOG } from 'src/components/DefaultLoadingDialog/DefaultLoadingDialog';

function* loadAllNotifications(screenKey = ACTIVE_SCREEN_KEY) {
    const url = '/notifications/messages';
    const result = yield call(GET, url, getHeaders());

    if (result.isSuccess) {
        const allNotifications = result.response;
        const filteredNotifications = allNotifications.filter(notification => {
            return notification.Status !== DELETE && notification.Status !== READ;
        });
        const notificationCount = filteredNotifications.length;
        yield all([
            put(setScreenData(['allNotifications'], result.response, screenKey)),
            put(setScreenData(['notificationCount'], notificationCount, screenKey)),
        ]);
    } else {
        yield put(setScreenData(['isNotificationFetchFailed'], true, screenKey));
    }
}
export function* updateNotifications(messageId, status, screenKey = ACTIVE_SCREEN_KEY) {
    yield put(showDialog(DEFAULT_LOADING_DIALOG));
    const url = `/notifications/messages/${messageId}/status`;
    const allNotifications = toArray(getScreenData(Store().getState().screen, ['allNotifications'], ACTIVE_SCREEN_KEY));
    const body = {
        Status: `${status}`,
    };

    const result = yield call(PUT, url, getHeaders(), body);
    if (result.isSuccess) {
        const allNotificationsUpdated = allNotifications.map(x => {
            if (x.MessageID === messageId) {
                return { ...x, Status: status };
            }
            return x;
        });
        const filteredNotifications = allNotificationsUpdated.filter(notification => {
            return notification.Status !== DELETE && notification.Status !== READ;
        });
        const notificationCount = filteredNotifications.length;
        yield all([
            put(setScreenData(['allNotifications'], allNotificationsUpdated, screenKey)),
            put(setScreenData(['notificationCount'], notificationCount, screenKey)),
        ]);
    } else {
        yield put(setScreenData(['isNotificationFetchFailed'], true, screenKey));
    }
    yield put(hideDialog(DEFAULT_LOADING_DIALOG));
}

export default loadAllNotifications;
